import { itemHasContent } from '../../utils/helpers';

/**
 * Calculates a section's progress based on the number of items that have content.
 * @param {Array} collectionItems - The items to calculate progress for
 * @param {number} minRequired - The minimum number of items required to have content
 * @returns {number} The progress percentage
 */
export function calculateSectionProgress(collectionItems, minRequired = 1) {
  let sectionProgress = 0;
  // At least {minRequired} items are required, but we still calculate progress if fewer exist
  // Progress is 0 if there are no items
  // if there are items then we need to check if each item has content
  if (collectionItems.length === 0) {
    sectionProgress = 0;
  } else {
    // count the number of items that have content
    const filledCount = collectionItems.reduce(
      (acc, item) => acc + (itemHasContent(item) ? 1 : 0),
      0,
    );

    // denominator is assigned so that the followign conditions are true:
    // - if there are fewer items than minRequired, the progress is 0
    // - if there are more items than minRequired, the progress is the percentage of items that have content
    // - if there are exactly minRequired items, the progress is 100%
    const denominator = Math.max(minRequired, collectionItems.length);
    sectionProgress = Math.round((filledCount / denominator) * 100);
  }

  return sectionProgress;
}

export function calculateKeyActivityProgress(rootState) {
  return calculateSectionProgress(rootState.keyActivity.collection, 1);
}

export function calculateKeyPartnerProgress(rootState) {
  return calculateSectionProgress(rootState.keyPartner.collection, 1);
}

export function calculateKeyResourceProgress(rootState) {
  return calculateSectionProgress(rootState.keyResource.collection, 1);
}
